module.exports = __webpack_public_path__ + "img/dec-indent.01b5a45b.svg";